import { render, staticRenderFns } from "./divider-position.mpx?vue&type=template&id=36b6bcb2&isComponent&outputPath=components%2Fdivider-position7df3a136%2Findex"
import script from "./divider-position.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fdivider-position7df3a136%2Findex"
export * from "./divider-position.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fdivider-position7df3a136%2Findex"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports